import { Component, ViewEncapsulation } from '@angular/core';
import { ProductDetailsTabComponent } from '@spartacus/storefront';

@Component({
    selector: 'app-uig-product-details-tab',
    templateUrl: './uig-product-details-tab.component.html',
    styleUrls: ['./uig-product-details-tab.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigProductDetailsTabComponent extends ProductDetailsTabComponent {
}
